const faqList = [
  {
    question: "FACEONE은 어떤 서비스인가요?",
    answer: "FACEONE은 인공지능 기반 얼굴 인식 기술을 활용하여 출입 관리, 출석 체크, 보안 인증 등 다양한 분야에 적용 가능한 스마트 솔루션입니다. 빠르고 정확한 얼굴 인식을 통해 효율적인 운영과 보안을 동시에 제공합니다."
  },
  {
    question: "FACEONE을 사용하려면 어떤 장비가 필요한가요?",
    answer: "FACEONE은 기본적으로 카메라가 장착된 디바이스(PC, 태블릿, 키오스크 등)와 인터넷 연결이 필요합니다. 고정형 또는 이동형 장비 모두 지원하며, 고객의 환경에 맞는 맞춤형 설치도 가능합니다."
  },
  {
    question: "얼굴 인식 데이터는 안전하게 보호되나요?",
    answer: "네, FACEONE은 개인정보 보호법 및 관련 규정을 철저히 준수하며, 얼굴 인식 데이터는 암호화되어 안전하게 저장됩니다. 또한, 고객의 동의 없이 제3자에게 데이터를 제공하지 않습니다."
  },
  {
    question: "서비스 도입까지 얼마나 걸리나요?",
    answer: "일반적으로 상담 후 설치 및 세팅까지 약 3~7일 정도 소요됩니다. 고객의 요구사항에 따라 커스터마이징이 필요한 경우, 일정이 조정될 수 있습니다."
  },
  {
    question: "기술 지원은 어떻게 받을 수 있나요?",
    answer: "FACEONE은 365일 고객 지원 센터를 운영하고 있으며, 전화, 이메일, 실시간 채팅을 통해 기술 지원을 제공합니다. 또한, 원격 지원 서비스도 제공하여 빠른 문제 해결이 가능합니다."
  },
  // 필요한 만큼 FAQ 항목을 추가합니다.
];

export default faqList;